import BaseModel from 'models/base-model';

export default class AuditQuestion extends BaseModel({
  id: null,
  question: null,
  auditAnswer: null,
  answeredDate: null,
  answeredBy: null,
}) {}
